import React from 'react';
import { TouchableOpacity, View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import { Icon } from '../Icon';
import { getThemeImages, withTheme, LightThemeColors } from '../Themes';
import VFText from '../VFText';

import styles from './ErrorScreen.Styles';

const ErrorScreen = ({
  backgroundStyle,
  iconName,
  iconStyle,
  text,
  textStyle,
  tryButtonContainerStyle,
  textButton,
  txtButtonStyle,
  iconButtonName,
  iconButtonStyle,
  onPress,
  placeholders,
  extraInfo,
  iconAccessibilityLabel,
  arrowAccessibilityLabel,
  descAccessibilityLabel,
  tryAgainAccessibilityLabel,
  theme,
  images,
  ...props
}) => {
  const _images = images || getThemeImages(theme.name);
  return (
    <View
      style={[styles.background(theme), backgroundStyle]}
      testID={FoundationTestKeys.errorScreenView}
      {...props}
    >
      <Icon
        name={_images[iconName]}
        type="image"
        size={92}
        style={[styles.icon, iconStyle]}
        accessibilityLabel={iconAccessibilityLabel}
        testID={FoundationTestKeys.errorScreenIcon}
      />
      <VFText
        i18nKey={text}
        placeHolders={placeholders}
        style={[styles.text(theme), textStyle]}
        testKey={descAccessibilityLabel ?? FoundationTestKeys.errorScreenDescText}
      />
      <TouchableOpacity
        style={[styles.tryButton, tryButtonContainerStyle]}
        onPress={() => onPress(extraInfo)}
        accessible={false}
        testID={FoundationTestKeys.errorScreenTryAgainButton}
      >
        <VFText
          i18nKey={textButton}
          style={[styles.txtButton(theme), txtButtonStyle]}
          testKey={tryAgainAccessibilityLabel ?? FoundationTestKeys.errorScreenTryAgainText}
        />
        <Icon
          name={_images[iconButtonName]}
          type="image"
          size={26}
          style={[styles.iconButton, iconButtonStyle]}
          accessibilityLabel={arrowAccessibilityLabel}
          testID={FoundationTestKeys.errorScreenArrowIcon}
        />
      </TouchableOpacity>
    </View>
  );
};

ErrorScreen.defaultProps = {
  iconName: 'ic_WarningHiLight_Theme',
  text: 'An error has occurred and we’re having some trouble loading your content.',
  textButton: 'Try again',
  iconButtonName: 'ic_RefreshRed',
  onPress: () => {},
  theme: LightThemeColors,
};
ErrorScreen.propTypes = {
  backgroundStyle: ViewPropTypes.style,
  iconName: PropTypes.string,
  iconStyle: ViewPropTypes.style,
  text: PropTypes.string,
  textStyle: ViewPropTypes.style,
  textButton: PropTypes.string,
  tryButtonContainerStyle: ViewPropTypes.style,
  txtButtonStyle: ViewPropTypes.style,
  iconButtonName: PropTypes.string,
  iconButtonStyle: ViewPropTypes.style,
  onPress: PropTypes.func,
  placeholders: PropTypes.array,
  extraInfo: PropTypes.any,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  iconAccessibilityLabel: PropTypes.string,
  arrowAccessibilityLabel: PropTypes.string,
  descAccessibilityLabel: PropTypes.string,
  tryAgainAccessibilityLabel: PropTypes.string,
  images: PropTypes.object,
};
export default withTheme(ErrorScreen);
